import {changeEvent, customEvent, dispatchCustomEvent} from "../../../../../webpack/modules/events";
import {ajaxCalculateMultiPrices, trackProductPageGa4Events} from "../../../../../webpack/modules-optimized/product";
import {hideOffcanvas} from "../../../../../webpack/modules-optimized/offcanvas";
import {hideOptionErrors, updatePriceElements} from "../../../../../webpack/modules-optimized/product-page";

changeEvent('#product-page input[name="tissue"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let tissues = offcanvas.querySelectorAll('.tissue');
    let tissue = element.nextElementSibling;

    dispatchCustomEvent(
        'productTissueChanged',
        {
            'option': offcanvas,
            'previewElement': previewElement,
        }
    );

    tissues.forEach((tissue) => tissue.classList.remove('selected'));
    tissue.classList.add('selected');
    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    hideOptionErrors(offcanvas);
    hideOffcanvas(offcanvas.id);
    updatePriceElements(container);
    trackProductPageGa4Events('BlindTissue', element.dataset.preview);
});

customEvent('hidden.bs.offcanvas', '#product-page .options[data-type="size"]', false, function(element) {
    updateTissuesPrices(element.closest('.product-scope'));
});

async function updateTissuesPrices(container)
{
    let productId = container.dataset.productId;
    let customWidth = container.querySelector('.custom-size-width');
    let customHeight = container.querySelector('.custom-size-height');
    let width = customWidth.value || customWidth.dataset.min;
    let height = customHeight.value || customHeight.dataset.min;
    let size = width+'x'+height;
    let tissues = container.querySelectorAll('input[name="tissue"]');
    let data = [];

    tissues.forEach(function(tissue) {
        data.push(
            {
                productId: productId,
                quantity: 1,
                options: {
                    width: width,
                    height: height,
                    tissue: tissue.value
                }
            }
        );
    });

    let prices = await ajaxCalculateMultiPrices(data);

    container.querySelectorAll('.tissue .tissue-price').forEach(function(tissuePrice, key) {
        tissuePrice.innerHTML = tissuePrice.dataset.text.replace('%price%', prices.formattedPrices[key]).replace('%size%', size);
        // tissuePrice.classList.remove('d-none');
    });
}